'use client';

import { useRouter } from 'next/navigation';
import { useLayoutEffect } from 'react';

import Loader from '@/ui/loader/loader';

export default function NotFound() {
  const router = useRouter();

  useLayoutEffect(() => {
    router.replace('/en-US/error-page');
  });

  return (
    <html lang="en">
      <body style={{
        alignItems: 'center',
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        width: '100vw',
      }}
      >
        <Loader size={18} />
      </body>
    </html>
  );
}
